// Vue filters
import Vue from 'vue'

Vue.filter('price', function (value) {
  if (value || value === 0) {
    let splitValue = parseFloat(value).toFixed(2).toString().split('.')
    let newValue = ''

    for (let i = splitValue[0].length - 1; i >= 0; i--) {
      newValue = splitValue[0][i] + newValue
      if (i > 0 && newValue.replace('.', '').length % 3 === 0) newValue = '.' + newValue
    }

    newValue = newValue.replace('-.', '-')

    if (!splitValue[1]) newValue += ',00'
    else if (splitValue[1].length === 1) newValue += ',' + splitValue[1] + '0'
    else newValue += ',' + splitValue[1].substr(0, 2)

    newValue = 'R$ ' + newValue
    newValue = newValue.replace('R$ -', '- R$ ')

    return newValue
  } else {
    return value
  }
})

Vue.filter('priceInteger', function (value) {
  if (value || value === 0) {
    let splitValue = value.toString().split('.')
    let newValue = ''

    for (let i = splitValue[0].length - 1; i >= 0; i--) {
      newValue = splitValue[0][i] + newValue
      if (i > 0 && newValue.replace('.', '').length % 3 === 0) newValue = '.' + newValue
    }

    return newValue
  } else {
    return value
  }
})

Vue.filter('priceCents', function (value) {
  if (value || value === 0) {
    let splitValue = value.toString().split('.')
    let newValue = ''

    if (!splitValue[1]) newValue += '00'
    else if (splitValue[1].length === 1) newValue += splitValue[1] + '0'
    else newValue += splitValue[1].substr(0, 2)

    return newValue
  } else {
    return value
  }
})

Vue.filter('numberWithDots', function (value) {
  if (value || value === 0) {
    let stringValue = value.toString()
    let newValue = ''

    for (let i = stringValue.length - 1; i >= 0; i--) {
      newValue = stringValue[i] + newValue
      if (i > 0 && newValue.replace('.', '').length % 3 === 0) newValue = '.' + newValue
    }

    return newValue
  } else {
    return value
  }
})

Vue.filter('document', function (value) {
  if (value) {
    let stringValue = value.toString()
    if (stringValue.length === 11) {
      stringValue = stringValue.substr(0, 3) + '.' + stringValue.substr(3, 3) + '.' + stringValue.substr(6, 3) + '-' + stringValue.substr(9, 2)
    } else {
      stringValue = stringValue.substr(0, 2) + '.' + stringValue.substr(2, 3) + '.' + stringValue.substr(5, 3) + '/' + stringValue.substr(8, 4) + '-' + stringValue.substr(12, 2)
    }
    return stringValue
  } else {
    return value
  }
})

Vue.filter('documentMasked', function (value) {
  if (value) {
    let stringValue = value.toString()
    if (stringValue.length === 11) {
      stringValue = stringValue.substr(0, 3) + '.***.***-' + stringValue.substr(9, 2)
    } else {
      stringValue = stringValue.substr(0, 2) + '.' + stringValue.substr(2, 3) + '.' + stringValue.substr(5, 3) + '/' + stringValue.substr(8, 4) + '-' + stringValue.substr(12, 2)
    }
    return stringValue
  } else {
    return value
  }
})

Vue.filter('phone_number', function (value) {
  if (value) {
    let stringValue = value.toString()
    if (stringValue.length === 11) {
      stringValue = '(' + stringValue.substr(0, 2) + ') ' + stringValue.substr(2, 1) + ' ' + stringValue.substr(3, 4) + '-' + stringValue.substr(7, 4)
    } else if (stringValue.length === 10) {
      stringValue = '(' + stringValue.substr(0, 2) + ') ' + stringValue.substr(2, 4) + '-' + stringValue.substr(6, 4)
    }
    return stringValue
  } else {
    return value
  }
})

Vue.filter('payment_method', function (value) {
  if (value === 'monthly') return 'mensal'
  if (value === 'quarterly') return 'trimestral'
  if (value === 'semiannual') return 'semestral'
  if (value === 'yearly') return 'anual'
  return value
})

Vue.filter('role', function (value) {
  if (value === 'financial') return 'Financeiro/Organizador'
  if (value === 'organizer') return 'Organizador'
  if (value === 'participant') return 'Participante'
  return value
})

Vue.filter('boolean', function (value) {
  if (value === true) return 'Sim'
  if (value === false) return 'Não'
})

Vue.filter('invoice_status', function (value) {
  if (value === 'paid') return 'Pago'
  if (value === 'late') return 'Atrasado'
  if (value === 'pending') return 'Em aberto'
  if (value === 'canceled') return 'Cancelado'
  if (value === 'renegotiated') return 'Renegociado'
  if (value === 'update') return 'Atualizando...'
  if (value === 'cancel') return 'Cancelando...'
  if (value === 'create') return 'Criando...'
  if (value === 'wait') return 'Criando...'
  if (value === 'synchronize') return 'Sincronizando...'
  return 'Indefinido'
})

Vue.filter('percent', function (value) {
  return `${value.toString().replace('.', ',')} %`
})

Vue.filter('fee_type', function (value) {
  const map = {
    credit_card_fee: 'Taxa no Cartão',
    heppi_fee: 'Taxa no Boleto'
  }

  return map[value]
})

Vue.filter('gateway_response_status', function (value) {
  if (value === 'pending') return 'Pendente'
  if (value === 'approved') return 'Aprovado'
  if (value === 'cancelled') return 'Cancelado'
  if (value === 'rejected') return 'Rejeitado'
  return value
})

Vue.filter('processing_mode', function (value) {
  if (value === 'increment') return 'Adicionado'
  if (value === 'decrement') return 'Descontado'
  return value
})

Vue.filter('fee_type', function (value) {
  if (value === 'bank_slip') return 'Boleto'
  if (value === 'credit_card') return 'Cartão'
  return value
})

Vue.filter('mp_status', function (value) {
  if (value === 'approved') return 'Aprovado'
  if (value === 'in_process') return 'Em processamento'
  if (value === 'rejected') return 'Rejeitado'
  if (value === 'cancelled') return 'Expirado'
  if (value === 'expired') return 'Expirado'
  return value
})

Vue.filter('product_reference', function (value) {
  if (value === 'experience') return 'Experiência'
  if (value === 'fundraising') return 'Arrecadação'
  return value
})

Vue.filter('installmentCategory', function (value) {
  if (value === 'fundraising') return 'Parcela'
  if (value === 'interest_and_fines') return 'Multa/juros'
  if (value === 'renegotiation') return 'Renegociação'
  if (value === 'additional') return 'Adicional'
  if (value === 'discount') return 'Desconto'
  return value
})

Vue.filter('ticketStatus', function (value) {
  if (value === 500000087) return 'Aberto'
  if (value === 500000086) return 'Em andamento'
  if (value === 500000085) return 'Em andamento' // Unscheduled
  if (value === 500000105) return 'Retornado'
  if (value === 500000091) return 'Finalizado'
  return 'Indefinido'
})
